import type { RuntimeConfig } from 'nuxt/schema'
import getDefaultLocale from '../locale/getDefaultLocale'
import { H3Event } from 'h3'

export default (event?: H3Event, config?: RuntimeConfig, url?: URL): DefaultCountryId => {
  return Number(getDefaultLocale(event, config, url).id) || null
}

type DefaultCountryId = number | null
